import { useMemo } from 'react';
import { useGetInstallCompatibilityQuery } from '../../__generated__/chirp/com/hubspot/marketplace/installs/rpc/MarketplaceInstallsRpc.hooks';
import { useGetInstallCompatibilityQuery as useGetInstallCompatibilityQueryApp } from '../../__generated__/chirp/com/hubspot/marketplace/installs/rpc/MarketplaceInstallsRpc-app.hooks';
export function useInstallCompatibility({
  listingId,
  published = true,
  skip = false,
  appContext
}) {
  const {
    data: installCompatibilityDataPublic,
    loading: installCompatibilityLoadingPublic,
    error: installCompatibilityErrorPublic
  } = useGetInstallCompatibilityQuery({
    variables: {
      listingId: listingId,
      published
    },
    skip: skip || !listingId || appContext !== 'public'
  });
  const {
    data: installCompatibilityDataInApp,
    loading: installCompatibilityLoadingInApp,
    error: installCompatibilityErrorInApp
  } = useGetInstallCompatibilityQueryApp({
    variables: {
      listingId: listingId,
      published
    },
    skip: skip || !listingId || appContext !== 'app'
  });
  const data = appContext === 'app' ? installCompatibilityDataInApp : installCompatibilityDataPublic;
  const compatibilityType = useMemo(() => {
    if (!(data !== null && data !== void 0 && data.productInstallCompatibility)) {
      return 'COMPATIBLE_NONE';
    }
    const {
      featureCompatibilities,
      installability,
      portalTiers
    } = data.productInstallCompatibility;
    if ((installability === null || installability === void 0 ? void 0 : installability.portalInstallable) === false) {
      return 'COMPATIBLE_NONE';
    }
    if (!(featureCompatibilities !== null && featureCompatibilities !== void 0 && featureCompatibilities.length)) {
      return 'COMPATIBLE_ALL'; // No features to check, consider compatible
    }
    let compatibleFeatureCount = 0;
    for (const feature of featureCompatibilities) {
      // Check if this feature has any tier that matches our portal tiers
      const hasCompatibleTier = feature.compatibleTiers.some(tier => portalTiers.includes(tier));
      if (hasCompatibleTier || feature.compatibleTiers.length === 0) {
        compatibleFeatureCount++;
      }
    }
    if (compatibleFeatureCount === featureCompatibilities.length) {
      return 'COMPATIBLE_ALL';
    } else if (compatibleFeatureCount > 0) {
      return 'COMPATIBLE_SOME';
    } else {
      return 'COMPATIBLE_NONE';
    }
  }, [data]);
  return {
    compatibilityType,
    data,
    loading: appContext === 'app' ? installCompatibilityLoadingInApp : installCompatibilityLoadingPublic,
    error: appContext === 'app' ? installCompatibilityErrorInApp : installCompatibilityErrorPublic
  };
}